import React, { FC } from 'react';
import { TextField } from '@material-ui/core';
import _ from 'lodash';
import { Controller } from 'react-hook-form';

type Props = {
  control: any;
  register: any;
  errors: any;
  name: string;
  label?: string;
  required?: boolean;
};
const ClientTextFieldController: FC<Props> = ({
  control,
  register,
  errors,
  name,
  label,
  required,
}) => {
  return (
    <Controller
      as={TextField}
      control={control}
      id="filled-error-helper-text"
      name={name}
      variant="outlined"
      label={label || _.upperFirst(name)}
      style={{ width: '100%', marginTop: '25px' }}
      helperText={errors[name] ? errors[name].message : ''}
      inputRef={register}
      error={errors[name] !== undefined}
      InputLabelProps={required ? { required: true } : undefined}
    />
  );
};

export default ClientTextFieldController;
